import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AuthenticationWrapper from 'components/layout/AuthenticationWrapper';
import { REGISTER, GAME, LANDING, FORGOT_PASSWORD, CREATING_TOURNAMENT } from 'constants/routes';
import { validateReturnPath } from 'utils/navigation';
import { ButtonFilled } from 'components/ui/Button';
import { useUser } from 'api/userService';
import Cookies from 'js-cookie';
import { getCookieDomainFromUrl } from 'utils';
import { createTournament } from 'api/tournamentService';

import {
  Title,
  Text,
  IntroHead,
  StyledInput,
  BottomWrapper,
  ForgotPasswordLink,
} from './styled';

const domain = getCookieDomainFromUrl(process.env.REACT_APP_LANDING_PAGE);
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const { login } = useUser();
  const location = useLocation();
  const locationState = location.state as { from?: string } | null;
  const stateFrom = validateReturnPath(locationState?.from);
  const intendedTournamentId = localStorage.getItem('intendToJoinTournament') ?? Cookies.get('intendToJoinTournament');
  const pendingTournamentData = localStorage.getItem('pendingTournamentData');

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      await login(email, password, async token => {
        if (pendingTournamentData) {
          // Redirect to tournament creation page
          window.location.href = CREATING_TOURNAMENT.replace(':id', '1');
        } else if (intendedTournamentId) {
          localStorage.removeItem('intendToJoinTournament');
          Cookies.remove('intendToJoinTournament', { path: '/', domain });
          // Redirect to the specific tournament page
          window.location.href = `${GAME.replace(':id', intendedTournamentId)}`;
        } else {
          const currentPath = window.location.pathname;
          if (currentPath !== '/') {
            // On a protected route rendered inline — reload to show actual component
            setTimeout(() => {
              window.location.reload();
            }, 250);
          } else if (stateFrom) {
            // Returned from Register with a from state (Login→Register→Login round-trip)
            setTimeout(() => {
              window.location.href = stateFrom;
            }, 250);
          } else {
            setTimeout(() => {
              window.location.href = LANDING;
            }, 250);
          }
        }
      });
    } catch (error: unknown) {
      console.error('Login error:', error);
      if (typeof error === 'object' && error !== null && 'error' in error && typeof (error as { error: { message: string } }).error.message === 'string') {
        setError((error as { error: { message: string } }).error.message);
      } else {
        setError('An unexpected error occurred');
      }
    }
  };
  return (
    <AuthenticationWrapper>
      <IntroHead>
        <Title>Welcome back!</Title>
      </IntroHead>
      <form onSubmit={handleSubmit}>

        <StyledInput
          label="E-mail"
          value={email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
        />

        <StyledInput
          label="Password"
          type="password"
          value={password}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
          errorText={error}
        />

        <ForgotPasswordLink>
          <Link to={FORGOT_PASSWORD}>Forgot password?</Link>
        </ForgotPasswordLink>

        <BottomWrapper>
          <ButtonFilled type="submit">Log in</ButtonFilled>
          <Text>New here? <Link to={REGISTER} state={{ from: window.location.pathname !== '/' ? window.location.pathname + window.location.search : undefined }}>Register now</Link></Text>
        </BottomWrapper>

      </form>
    </AuthenticationWrapper>
  );
};

export default Login;
